// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","216":"forbidden","357":"unauthorized","523":"shop","571":"settings"}[chunkId] || chunkId) + "." + {"177":"d61f101c","216":"259b7ff6","357":"e284b638","523":"7228ff67","571":"ebe276a5","865":"be431610","964":"e5b44a19"}[chunkId] + ".css";
};